import axios from "axios";
import { CorpPRModel } from "models";
import { IAPIResult } from "models/interfaces";
import { Utils } from "utils";

export async function detail() {
  // await Utils.sleep(300);

  const response = await axios.get<IAPIResult<CorpPRModel>>(
    "/api.d/v1/ec/corp-profile/detail"
  );

  const data = response.data?.data;
  if (data && !data.is_registered && !data.catch_phrase) {
    data.catch_phrase = "";
    data.logo_image = {
      file_name: "",
      image_url: "",
    };
    data.corp_image = {
      file_name: "",
      image_url: "",
    };
    data.corp_category_list = [{ corp_large_category_id: "" }];
    data.corp_tag_list = [];
    data.introduction = "";
    data.pr_image_text_1 = "";
    data.pr_image_text_2 = "";
    data.pr_image_text_3 = "";
    data.pr_image_1 = {
      file_name: "",
      image_url: "",
    };
    data.pr_image_2 = {
      file_name: "",
      image_url: "",
    };
    data.pr_image_3 = {
      file_name: "",
      image_url: "",
    };
  }

  if (data.pr_image_text_1 === null) {
    data.pr_image_text_1 = "";
  }
  if (data.pr_image_text_2 === null) {
    data.pr_image_text_2 = "";
  }
  if (data.pr_image_text_3 === null) {
    data.pr_image_text_3 = "";
  }

  return response.data;
}

export async function preCheck(options: CorpPRModel) {
  // await Utils.sleep(300);

  const response = await axios.post<IAPIResult>(
    "/api.d/v1/ec/corp-profile/creation-check",
    options
  );
  return response.data;
}

export async function update(data: CorpPRModel) {
  // await Utils.sleep(300);

  Utils.addDeleteFlag(data.logo_image);
  Utils.addDeleteFlag(data.corp_image);
  Utils.addDeleteFlag(data.pr_image_1);
  Utils.addDeleteFlag(data.pr_image_2);
  Utils.addDeleteFlag(data.pr_image_3);
  const response = await axios.post<IAPIResult>(
    "/api.d/v1/ec/corp-profile/create",
    data
  );
  return response.data;
}
